import { CryptoCurrencyEnum } from "@/consts/CryptoCurrencyEnum";
import { getPublicConfig } from "@/helpers/getPublicConfig";
import { CurrencyEnum } from "@/server/graphql/generated/generated-types";

export const getPriceLimit = (currency: CurrencyEnum) => {
  const config = getPublicConfig();
  const { hkd, usd } = config.service.stripe.priceLimit;
  switch (currency) {
    case CurrencyEnum.Hkd: {
      const { max, min } = hkd;
      return { max, min };
    }
    case CurrencyEnum.Usd: {
      const { max, min } = usd;
      return { max, min };
    }
    default:
      return { max: 0.5, min: 2000 };
  }
};

/**
 * default return eth limit
 */
export const getCryptoPriceLimit = (
  currency: CryptoCurrencyEnum = CryptoCurrencyEnum.Eth,
) => {
  const config = getPublicConfig();
  const { eth } = config.service.ethereum.priceLimit;
  switch (currency) {
    case CryptoCurrencyEnum.Eth: {
      const { max, min } = eth;
      return { max, min };
    }
    default:
      return { max: eth.max, min: eth.min };
  }
};
